<template>
  <div>
    <div class="block_5 flex-col">
          <span class="paragraph_1">
            &ensp;&ensp;&ensp;&ensp;公司是以经营校园超市和发展连锁门店为主要业务，目前，公司服务的学校有重庆机电职业技术大学、重庆电讯职业学院、宿迁泽达职业技术学院、周口师范学院、保定理工学院、河北科技学院、南昌大学共青学院等十余所高校，服务全体规模约50万人。
            <br />
            &ensp;&ensp;&ensp;&ensp;公司秉持“聚焦校园，服务师生”的宗旨，努力实现把可可百汇超市打造成为“快乐消费、服务温馨、勤工助学、育人为本“的特色超市。
          </span>
      <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="../assets/img/img3.webp"
      />
    </div>
    <div class="block_6 flex-col">
          <span class="paragraph_2">
            &ensp;&ensp;&ensp;&ensp;公司目前下设综合办公室、商超部和市场部二个职能部门、一个集中采购配供中心、12家门店，现有正式员工150余人，其中大专以上学历人员10余人。经过多年的发展，公司下属可可百汇超市连锁门店规范经营，逐步实现七个统一，即统一形象、统一标识、统一采购、统一配送、统一定价、统一销售、统一管理，先后通过了ISO9001：2000、IS09001：
2008、ISO9001:2012质量管理体系的认证。在售商品2万余种，覆盖了食品、日化、百货、文体、娱乐、休闲等各个层面的需求，满足师生多元需求。
          </span>
      <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="../assets/img/img4.webp"
      />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        constants: {}
      };
    },
    methods: {}
  };
</script>
<style scoped lang="css" src="../assets/index.css" />
